<template>
	<div  v-loading.fullscreen.lock="loading" class="msg_box">
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">订单详情</span>
			</div>
		</div>
		<div class="details_box clearfloat">
			<div class="flo_lf details_left" v-if="order.address">
				<div class="left_top">
					物流信息
				</div>
				<div class="left_zpz">
					<div class="mos">收货地址</div>：
					<div class="zpz_content">
						{{order.address.realname}}
						{{order.address.addr }}
						{{order.address.address}}
					</div>
				</div>
				<div class="left_zpz">
					<div class=" mos">订单编号</div>：
					<div class="zpz_content">{{order.out_trade_no}}</div>
				</div>
				<div class="left_zpz">
					<div class=" mos w3">联系人</div>：
					<div class="zpz_content">{{order.address.realname}}</div>
				</div>
				<div class="left_zpz">
					<div class=" mos w2">单位</div>：
					<div class="zpz_content">{{order.address.unit}}</div>
				</div>
				<div class="left_zpz">
					<div class=" mos">联系电话</div>：
					<div class="zpz_content">{{order.address.phone}}</div>
				</div>
			</div>
			<div class="flo_right details_right">
				<div class="shehe">
					订单状态：
					<div class="lanse">{{order.status | oredrS}}</div>
					<div v-if="order.remarks&&order.status==3" class="fah_beizhu">
						<span>发货备注：</span>
					<span class="fah_val">{{order.remarks}}</span>
				</div>
		</div>
			</div>
			<!-- <div class="flo_right details_right">
				<div class="left_top">
					订单状态：
				</div>
				<div class="czosa">
					{{order.status | oredrS}}
				</div>
				<div class="left_top">
					发货状态：部分发货
				</div>
				<div class="wei_zi">
					<div class="">n-Octyl-β-D-thioglucoside：已发货</div>
					<div class="">n-Octyl-β-D-thioglucoside：已发货</div>
				</div>
			</div> -->
		</div>
		<div>
			<p class="font20">卖家信息</p>
			<div class="zxcc">
				<span @click="xin.goUrl('/aboutUs/contactUs')" class="lan">联系我们</span>
				<span class="">邮箱：info@dojindo.cn</span>
				<span>
					微信公众号:<span class="lan" @click="isEwm=true">【同仁化学DOJINDO】</span>
				</span>
			</div>
		</div>
		<div class="tech_title">订单信息</div>
		<div class="order_to"><span>货号</span>
			<span>商品名称</span>
			<span>规格</span>
			<span>单价</span>
			<span>商品数量</span>
			<span>总价</span>
		</div>
		<div class="chopping_box">
			<div class="chopping_zi" v-for="(itme) in order.goods" :key="itme.id">
				<div class="chopping_li">
					{{itme.id}}
				</div>
				<div class="chopping_li chopping_goods clearfloat">
					<img @click="xin.goUrl('/goodsDetails',{gid:itme.goods_id})" class="" :src="itme.goods_images" />
					<div class=" asdmoi">
						<div class="erjihuanhang" >
							<span class="lan" @click="xin.goUrl('/goodsDetails',{gid:itme.goods_id})">{{itme.goods_name}}</span>
						</div>
						<div class="erjihuanhang">
							<span @click="xin.goUrl('/oneDetails',{cid:itme.category_1})" class="cur_po">{{itme.category_name}}</span>
						</div>
					</div>
				</div>
				<div class="chopping_li">
					{{itme.sku_value}}
				</div>
				<div class="chopping_li">
					¥{{itme.sale_price}}
				</div>
				<div class="chopping_li">
					{{itme.goods_number}}
				</div>
				<div class="chopping_li">
					¥{{itme.sale_price * itme.goods_number | maniu}}
				</div>
			</div>
		</div>
		<div class="details_bottom clearfloat">
			<div class="flo_lf" v-if="order.invoice">
				<div class="bot_title">发票信息</div>
				<div class="bot_zi">发票类型：{{order.invoice.type==1?'专票':'普票'}}</div>
				<div class="bot_zi">发票抬头：{{order.invoice.look}}</div>
				<div class="bot_zi">纳税人识别号：{{order.invoice.identify_number}}</div>
				<div class="bot_zi">专票信息（普票无需填写）：</div>
				<textarea readonly :value="order.invoice.info">
				</textarea>
				<div class="bot_zi"><span class="w2">备注</span>：{{order.invoice.note}}</div>
			</div>
			<div class="flo_right">
				<div>总金额：
				<template v-if="order.alter_payable">
					<span class="xiaos">￥{{order.goods_payable}} </span>
					<span class="jing">￥{{order.alter_payable}}</span>
				</template>
				<span v-else class="jing">￥{{order.goods_payable}}</span>
				</div>
				<button v-notClick="isTosub" v-if="order.status==1||order.status==2" class="laing_btn" @click="Postoredrcancel()">取消订单</button>
				<button v-notClick="isTosub" v-if="order.status==4" @click="Postoredrconfirm()" class="laing_btn">确认收货</button>
			</div>
		</div>
		<el-dialog class="erweima" title="扫码关注公众号" center :visible.sync="isEwm" width="400px">
			<img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/qrcode_for_gh_1bf2f15c3a63_430.jpg"/>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				isTosub:true,
				oid:0,
				loading:true,
				isEwm:false,
				order:{},//订单详情
				shoppingList: [{
						id: "082612",
						ismode: false,
						imgUrl: '../../assets/images/activity2.png',
						name: "n-Octyl-β-D-thioglucoside",
						stype: '危险化学品',
						specification: '5g',
						price: 44.33,
						number: 3
					},
					{
						id: "04812",
						ismode: true,
						imgUrl: '../../assets/images/activity2.png',
						name: "n-Octyl-β-D-thioglucoside",
						stype: '危险化学品',
						specification: '5g',
						price: 72.22,
						number: 1
					},
					{
						id: "84613",
						ismode: false,
						imgUrl: '../../assets/images/activity2.png',
						name: "n-Octyl-β-D-thioglucoside",
						stype: '危险化学品',
						specification: '5g',
						price: 753.10,
						number: 2
					}
				]
			}
		},
		created(){
			this.oid = this.$route.query.oid;
			this.Postoredrinfo();
		},
		filters:{
			maniu(val){
				return val.toFixed(2);
			}
		},
		watch:{
			$route(to,frm){
				this.oid=to.query.oid;
				this.Postoredrinfo();
			}
		},
		methods:{
			async Postoredrconfirm(){
				this.$confirm('您确定要确认收货吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					this.isTosub = false;
					let {data,code} = await this.api.Postoredrconfirm({orders_id:this.order.id});
					if(code==200){
						this.$message.success('订单收货成功!');
						this.Postoredrinfo();
					}
					this.isTosub = true;
				}).catch(() => {
				});
			},
			async Postoredrinfo(){//订单详情
				this.loading = true;
				let orders_id = this.oid;
				if(!orders_id)return;
				let {code,data} = await this.api.Postoredrinfo({orders_id});
				this.order = data;
				this.loading = false;
			},
			async Postoredrcancel(){//取消订单
				this.$confirm('您确定要取消订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					this.isTosub = false;
					let {code} = await this.api.Postoredrcancel({orders_id:this.order.id});
					if(code==200){
						this.$message.success('订单取消成功!');
						this.Postoredrinfo();
					}
					this.isTosub = true;
				});
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
.xiaos{
	color: #9b9b9b;
	font-size: 16px;
	text-decoration: line-through;
	margin-right: 10px;
}
.fah_beizhu{
	margin: 10px 0;
	.fah_val{
		color: #666;
	}
}
	.details_bottom{
		margin-top: 50px;
		color: #666;
		line-height: 36px;
		.laing_btn{
			margin-top: 50px;
		}
		.bot_title{
			color: #333;
			font-size: 20px;
		}
		textarea{
			width: 380px;
			min-height: 84px;
		}
	}
	.font20{
		font-size: 20px;
		color: #333;
	}
	.lanse{
		font-size: 36px;
		color: #005599;
		line-height: 48px;
	}
	.zxcc{
		& > span{
			margin-right: 166px;
		}
	}
	.details_box{
		border: 1px solid #D9D9D9;
		// height: 250px;
		.details_right{
			box-sizing: border-box;
			width: 50%;
			height: 100%;
			// border-left: 1px solid #D9D9D9;
			.czosa{
				height: 90px;
				text-align: center;
				line-height: 90px;
				font-size: 36px;
				color: #005599;
			}
			.wei_zi{
				padding:  30px 80px;
				div{
					font-size: 16px;
					font-weight: 500;
					color: #333333;
					line-height: 30px;
				}
			}
			.shehe{
				margin: 62px 110px;
			}
		}
		.left_top{
			padding-left: 40px;
			line-height: 40px;
			height: 40px;
			background-color: var(--themeColor);
			color: #fff;
		}
		.details_left{
			box-sizing: border-box;
			border-right: 1px solid #D9D9D9;
			width: 50%;
			padding-bottom: 20px;
			// padding: 20px 0 20px 40px;
			.left_zpz{
				padding-left: 40px;
				margin:  5px 0;
				color: #333333;
				display: flex;
				// justify-content: space-between;
				.w2{
					letter-spacing: 1.8em;
					    margin-right: 0;
				}
				.mos{
					width: 90px;
					margin-right: -1.4em;
					// letter-spacing:3px;
				}
				.zpz_content{
					font-size: 16px;
					color:#666666;
					line-height: 24px;
				}
			}
		}
	}
	.order_to {
		margin-top: 30px;
		color: #fff;
		height: 40px;
		background: #005599;
		display: flex;
		align-items: center;
		span:nth-child(2) {
			flex: 3;
			text-align: center;
		}
		span:not(:nth-child(2)) {
			flex: 1;
			text-align: center;
		}
	}
	.chopping_box {
		color: #333;
		.chopping_zi {
			display: flex;
			align-items: center;
			padding: 30px 0;
			height: 100px;
			border-bottom: 1px solid #D9D9D9;
			.chopping_li {}
			&>div {
				flex: 1;
				text-align: center;
			}
			.chopping_goods {
				flex: 3;
				display: flex;
				.asdmoi {
					text-align: left;
					height: 100px;
					// display: flex;
					// flex-direction: column;
					// justify-content: space-between;
					// align-items: flex-start;
					margin-left: 20px;
					& :nth-child(2){
						margin-top: 30px;
					}
				}
				img {
					cursor: pointer;
					width: 100px;
					height: 100px;
				}
			}
		}
	}
</style>
